import classNames from 'classnames'
import { EmptyCircleIcon } from '@/atoms/Icons/EmptyCircleIcon'
import { CaptionLG, CaptionSM, LabelSM } from '@/atoms/Text'
import { formatPrice } from '@/services/PriceFormatter'
import { CollectibleProductPack } from '@/types/codegen-federation'

interface CollectiblesSoldOutItemProps {
  pack: CollectibleProductPack
  fullPrice: number
  savings: number
}
export const CollectiblesPackSoldOutItem: React.FC<CollectiblesSoldOutItemProps> = ({ pack, fullPrice, savings }) => {
  return (
    <div
      key={pack?.id}
      className={classNames(
        'my-4 grid grid-cols-[32px_1fr_90px] rounded-lg border-2 p-4 grid-rows-[auto_auto] gap-x-2',
        'bg-core-gray-100 border-core-gray-400 text-core-gray-400',
      )}
    >
      <div className="col-start-1 row-span-full place-self-center justify-self-start">
        <EmptyCircleIcon size={24} color1="shaded-200" />
      </div>
      <div className="flex flex-row place-items-center space-x-2">
        <CaptionLG weight="bold" className="w-fit">
          {pack?.name}
        </CaptionLG>
        <CaptionSM color="white" className="m-1 w-fit rounded-xl bg-error-700 px-2 py-1 font-thin">
          Sold Out
        </CaptionSM>
      </div>
      <div className="col-start-3 row-span-full flex flex-wrap justify-end gap-2 place-self-center  justify-self-end text-right">
        {savings > 0 && (
          <CaptionLG color="core-gray-400" className="line-through">
            {formatPrice(fullPrice, { currency: 'USD', ignoreEmptyDecimal: true })}
          </CaptionLG>
        )}
        <CaptionLG>{formatPrice(pack?.price ?? 0, { currency: 'USD', ignoreEmptyDecimal: true })}</CaptionLG>
        {savings > 0 && (
          <div className="rounded-full bg-success-300 px-3 py-1">
            <LabelSM>Save {savings}%</LabelSM>
          </div>
        )}
      </div>
      <CaptionLG>{pack?.description}</CaptionLG>
    </div>
  )
}
